<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <v-card-title>
      Cancellation insurance
    </v-card-title>
    <v-card-text>
      <div class="" v-if="hklr.days_since_booking > 7" style="background-color: rgba(255, 165, 0, 0.25); border: 1px solid orange; padding: 12px; border-radius: 4px;">
        <v-row no-gutters>
          <v-col cols="1" class="d-flex align-center">
            <v-icon color="warning" size="24" class="mb-auto mt-1">mdi-alert</v-icon>
          </v-col>
          <v-col cols="11" class="orange--text">
            Normally, a cancellation insurance can only be added within 7 days after booking.
            This booking was made {{hklr.days_since_booking}} days ago.
          </v-col>
        </v-row>
      </div>
      <v-row no-gutters class="black--text mt-4">
        Add cancellation insurance for {{ hklr.insurance_amount  }}
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveCancellationInsurance">Add</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addHklrCancellationInsurance: false,
      huov_encrid: null,
      hklr_nr: '',
      hklr_bedrag: null,
      huov_code_moveto: null,
      hklr_nrKeuzes: [],
      hklr: {},
    }
  },
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.hklr_nrKeuzes.length = 0;
      this.hklr_dt = '';
      this.hklr_bedrag = '';
      this.hklr_nr = '';
      this.$axios
        .post("ares/json/ares/huov/hklr/getHklrDataToAddInsurance.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovToAddInsurance"
          },
          getHuovToAddInsurance: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false;
          } else {
            this.hklr = res.data.getHuovToAddInsurance;
            console.log('hklr', this.hklr);
            this.loading = false;
          }
        })

    },
    saveCancellationInsurance() {
      // Save cancellation insurance logic here
      this.$axios
        .post("ares/json/ares/huov/hklr/addHklrCancellationInsurance.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHklrCancellationInsurance"
          },
          addHklrCancellationInsurance: {
            huov_encrid: this.huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false;
          } else {
            setTimeout(() => { this.$router.reload('/huov/onHuov/' + this.huov_encrid); }, 2000);
            this.$store.dispatch('setSnackbar', {
                showing: true,
                text: 'Cancellation insurance added successfully.',
                color: 'success'
            });             
            this.loading = false;
            this.dialog = false;
          }
        })      
    }
  }
}
</script>

